<template>
  <van-popup v-model="show" round position="bottom">
    <div
      v-if="remoteMethod && $utils.checkType(remoteMethod) === 'function'"
      class="search-wrapper">
      <van-field
        class="mobile-field-style"
        v-model="query"
        clearable
        @input="triggerSearch"
        placeholder="输入和搜索"
      />
    </div>
    <van-picker
      show-toolbar
      :columns="options"
      :value-key="nameKey"
      :default-index="defaultIndex"
      confirm-button-text="确认选择"
      @confirm="onConfirm"
      @change="changeItem"
    >
      <div v-show="showAdd" slot="cancel" @click="useAndAdd">
        使用并新增
      </div>
    </van-picker>
  </van-popup>
</template>

<script>
import { Picker } from 'vant';
export default {
  name: 'OptionPicker',
  components: {
    [Picker.name]: Picker
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    value: {
      type: String | Number
    },
    uniqueKey: {
      type: String,
      default: 'id'
    },
    showAdd: {
      type: Boolean,
      default: false
    },
    remoteMethod: Function
  },
  computed: {
    defaultIndex() {
      let index = 0
      this.options.forEach((i, d) => {
        if (i[this.valueKey] === this.value) {
          index = d
        }
      })

      return index
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data() {
    return {
      show: false,
      query: ''
    }
  },
  methods: {
    open() {
      this.query = ''
      this.show = true
      let data = this.options.find(item=>item.id == this.value)
      if(data){
        this.query = data.name
      }
    },
    onConfirm(item) {
      const value = this.options.find(i => item[this.uniqueKey] === i[[this.uniqueKey]])[this.valueKey]

      this.$emit('update', value)
      this.show = false
    },
    changeItem(data,item){
      this.query = item.name
    },
    useAndAdd() {
      const {
        query
      } = this
      if (!query.trim()) {
        this.$Toast.fail('请输入内容')
        return
      }

      this.$emit('add', query)
      this.show = false
    },
    triggerSearch() {
      const queryText = this.query || ''

      if (this.remoteMethod && this.$utils.checkType(this.remoteMethod) === 'function') {
        this.remoteMethod(queryText)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .mobile-field-style {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .search-wrapper {
    padding: 10px 16px 0;
  }
</style>